import { httpClient } from '@/network/clientController'

/** Get Channels List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_channels
*/
export const getChannelsList = () => {
    return httpClient({
		method: 'GET',
		url: 'channels',
		isCancellable: true
	})
}

/** Update Channel Active State
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_channelstoggle
*/
export const updateChannelActiveState = (payload) => {
    return httpClient({
		method: 'PUT',
		url: 'channels/toggle',
        data: payload
	})
}
